import store from '@state/store'

// auth related routes
const authRoutes = [
  {
    path: '/',
    name: 'homepage',
    badge: {
      text: '1',
      varient: 'success',
    },
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),

    // // component: () => lazyLoadView(import('@views/pages/homepage/index')),
    // component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    // meta: {
    //   beforeResolve(routeTo, routeFrom, next) {
    //     next()
    //   },
    // },
  },
  {
    path: '/submission/:id',
    name: 'submission',
    component: () => lazyLoadView(import('@views/pages/submission/preview')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/inbox',
    name: 'inbox',
    component: () => lazyLoadView(import('@views/pages/inbox/index')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/office',
    name: 'office',
    component: () => lazyLoadView(import('@views/pages/office/index')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => lazyLoadView(import('@views/pages/homepage/search')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/pages/account/profile')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/pages/:id',
    name: 'pages',
    component: () => lazyLoadView(import('@views/pages/homepage/pages.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/compilation',
    name: 'compilation',
    component: () => lazyLoadView(import('@views/pages/homepage/compilation.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next('dashboard')
          // next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/pages/account/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/pages/account/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
      lazyLoadView(import('@views/pages/account/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {

        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom }
        )
      },
    },
  },
]

// error pages
const errorPagesRoutes = [
  {
    path: '/404',
    name: '404',
    meta: {
      authRequired: true,
    },
    component: require('@views/error').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/500',
    name: '500',
    component: require('@views/pages/secondary/error-500').default,
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'Beranda',
    header: 'Navigation',
    icon: 'home',
    badge: {
      text: '1',
      varient: 'success',
    },
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const helpRoutes = [
  {
    path: '/help',
    name: 'Bantuan',
    header: 'Navigation',
    icon: 'help-circle',
    component: () => lazyLoadView(import('@views/pages/help/index')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/help-public',
    name: 'Petunjuk dan Bantuan',
    icon: 'help-circle',
    show: 0,
    component: () => lazyLoadView(import('@views/pages/help/index-public')),
    meta: { authRequired: false },
  },
  {
    path: '/suggestion',
    name: 'suggesti',
    icon: 'help-circle',
    show: 0,
    component: () => lazyLoadView(import('@views/pages/help/suggestion')),
    meta: { authRequired: false },
  },
]

const entryAppsRoutes = [
  {
    path: '/apps/entries',
    name: 'Kalkulasi',
    icon: 'file-text',
    role: ['ADMIN','CLIENT','JAKSA'],
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        name: 'Lihat Isian',
        path: 'index',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () =>
          lazyLoadView(import('@views/pages/apps/entries/index')),
      },
      {
        name: 'Buat baru',
        path: 'new',
        meta: { authRequired: true },
        role: ['ADMIN','CLIENT','JAKSA'],
        component: () =>
          lazyLoadView(import('@views/pages/apps/entries/new')),
      },
      {
        name: 'Ubah data',
        path: 'edit/:id',
        icon: 'plus',
        meta: { authRequired: true },
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/entries/new')),
      },
      {
        name: 'Lihat data',
        path: 'preview/:id',
        meta: { authRequired: true },
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/entries/preview')),
      },
    ]
  }
];

const masteryAppsRoutes = [
  {
    path: '/apps/mastery',
    name: 'Master',
    icon: 'box',
    role: ['ADMIN'],
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      // {
      //   name: 'Categories',
      //   path: 'category',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/apps/category/index')),
      // },
      // {
      //   name: 'New Data',
      //   path: 'category/add',
      //   meta: { authRequired: true },
      //   show: 0,
      //   component: () =>
      //     lazyLoadView(import('@views/pages/apps/category/add')),
      // },
      // {
      //   name: 'Edit Category',
      //   path: 'category/edit/:id',
      //   meta: { authRequired: true },
      //   show: 0,
      //   component: () =>
      //     lazyLoadView(import('@views/pages/apps/category/edit')),
      // },
      {
        name: 'Pengguna',
        path: 'user',
        meta: { authRequired: true },
        role: ['ADMIN'],
        component: () =>
          lazyLoadView(import('@views/pages/apps/user/index')),
      },
      {
        name: 'Kantor',
        path: 'office',
        meta: { authRequired: true },
        role: ['ADMIN'],
        component: () =>
          lazyLoadView(import('@views/pages/apps/office/index')),
      },
      {
        name: 'Saran dan Laporan',
        path: 'suggestion',
        meta: { authRequired: true },
        role: ['ADMIN'],
        component: () =>
          lazyLoadView(import('@views/pages/apps/suggestion/index')),
      },
      {
        name: 'Ubah Pengguna',
        path: 'user/edit/:id',
        meta: { authRequired: true },
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/user/edit')),
      },
      {
        name: 'Ubah Kata Sandi Pengguna',
        path: 'user/change-password/:id',
        meta: { authRequired: true },
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/user/change-password')),
      },
      {
        name: 'Tambah Kantor',
        path: 'office/add',
        meta: { authRequired: true },
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/office/add')),
      },
      {
        name: 'Ubah Kantor',
        path: 'office/edit/:id',
        meta: { authRequired: true },
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/office/edit')),
      },
      {
        name: 'Tambah Pengguna',
        path: 'user/add',
        meta: { authRequired: true },
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/user/add')),
      },
      {
        name: 'Bulk upload',
        path: 'user/bulk',
        meta: { authRequired: true },
        show: 0,
        show: 0,
        component: () =>
          lazyLoadView(import('@views/pages/apps/user/bulk')),
      },
      // {
      //   name: 'Attachments',
      //   path: 'attachments',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/apps/attachments/index')),
      // },
      // {
      //   name: 'Pages',
      //   path: 'pages',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/apps/pages/index')),
      // },
      // {
      //   name: 'Add Page',
      //   path: 'pages/add',
      //   meta: { authRequired: true },
      //   show: 0,
      //   component: () =>
      //     lazyLoadView(import('@views/pages/apps/pages/add')),
      // },
      // {
      //   name: 'Edit Page',
      //   path: 'pages/edit/:id',
      //   meta: { authRequired: true },
      //   show: 0,
      //   component: () =>
      //     lazyLoadView(import('@views/pages/apps/pages/edit')),
      // },
    ],
  }
];

const appsRoutes = [
  ...entryAppsRoutes,
  ...masteryAppsRoutes,
]

const authProtectedRoutes = [
  ...dashboardRoutes,
  ...helpRoutes,
  ...appsRoutes
]
const allRoutes = [...authRoutes, ...authProtectedRoutes, ...errorPagesRoutes]

export { allRoutes, authProtectedRoutes }

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@components/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    // error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
